export const ALLOWED_FILE_SIZE_IN_MB = 30
export const ALLOWED_POSTMARK_ATTACHMENTS_SIZE_IN_MB = 10
export const MAX_ATTACHMENTS_AMOUNT = 10
